module.exports = __webpack_public_path__ + "static/media/patreon-logo-white.c9fa3329.svg";